<template>
  <div class="offcanvas-body">
    <LoadingContainer v-if="isPending" />
    <CheckboxInput
      v-else
      :options="occupationOptions"
      :model="occupationAreasModel"
      @onChange="handleSelect"
    />
  </div>
  <div class="offcanvas-footer">
    <FormButton
      :marginVertical="false"
      label="Concluir"
      :loading="submitting"
      @onClick="submit"
      :disabled="!meta.valid"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { toTypedSchema } from "@vee-validate/zod";
import { useForm } from "vee-validate";
import { useVeeField } from "@/composables/useVeeField";
import { specialtiesSchema } from "@/schemas/profile";
import { useSessionStore } from "@/store/useSessionStore";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { useOccupationAreas } from "@/composables/useSettings";
import { useUpdateUser } from "@/composables/useAuth";

const sessionStore = useSessionStore();
const session = computed(() => sessionStore.session);
const submitting = ref(false);

const { occupationAreas: allOccupations, isPending } = useOccupationAreas();

const { handleSubmit, meta, resetForm } = useForm({
  validationSchema: toTypedSchema(specialtiesSchema),
  initialValues: { occupation_areas: [] },
});

const occupationAreasModel = useVeeField<number[]>("occupation_areas");

onMounted(() => {
  resetForm({
    values: {
      occupation_areas:
        session.value?.occupations.map((o: any) => o.occupation_area_id) ?? [],
    },
  });
});

const occupationOptions = computed(() =>
  allOccupations.value.map((o) => ({
    ...o,
    name: o.title,
    selected: occupationAreasModel.$model.includes(o.id),
  })),
);

const { mutateAsync: updateUser } = useUpdateUser();

function handleSelect() {
  if (occupationAreasModel.$model.length > 6) {
    alert("Você só pode selecionar 6 especialidades");
    occupationAreasModel.$model.pop();
  }
}

const submit = handleSubmit(async (values) => {
  try {
    submitting.value = true;
    await updateUser({
      id: session.value!.id,
      occupation_areas: values.occupation_areas,
    });
    EventBus.$emit(EventBusNames.SHOW_TOAST, {
      title: "Alterações feitas",
      msg: "Suas informações foram salvas",
    });
  } catch (error) {
    console.error(error);
  } finally {
    submitting.value = false;
  }
});
</script>
